export default "__VITE_ASSET__DGlRs3mK__"